<app-header></app-header>
<app-sidebar></app-sidebar>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">
  <div class="card bg-warning">
    <div class="card-header bg-primary">
      <i class="fa fa-search"></i> ประวัติรายการเบิกปัจจัยการผลิต
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-auto">
          <div class="input-group mb-3">
            <span class="input-group-text">
              <i class="fa fa-clock"></i> &nbsp; ปีที่ต้องการ
            </span>
            <select [(ngModel)]="data_select.year" class="form-select">
              <option value="0000" disabled>กรุณาเลือกปี</option>
              <option value="6263">62/63</option>
              <option value="6364">63/64</option>
              <option value="6465">64/65</option>
              <option value="6566">65/66</option>
              <option value="6667">66/67</option>
              <option value="6768">67/68</option>
              <option value="6869">68/69</option>
            </select>
          </div>
        </div>
        <div class="col-auto">
          <div class="input-group mb-3">
            <span class="input-group-text">
              <i class="fa fa-user"></i>โควตา10หลัก
            </span>
            <input class="form-control" placeholder="ใส่เลขโควตา" type="text"
              onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="data_select.fmcode"
              maxlength="10" name="fmcode" id="fmcode">
            <span class="input-group-btn">
              <button type="button" (click)="Loaddata();" class="btn btn-primary btn-flat">ตกลง</button>
            </span>
          </div>
        </div>

        <div class="col-auto" *ngIf="oneaskmoney.length>0||onefactor.length>0">
          <div class="input-group mb-3">
            <span class="input-group-text">
              <i class="fa fa-search"></i>ค้นหา
            </span>
            <input class="form-control" placeholder="ค้นหา ข้อมูลในตาราง" type="text" [(ngModel)]="txtSearch">
          </div>
        </div>

        <div class="col-auto" *ngIf="editor[0]">
          <section>
            <mat-checkbox color="warn" [(ngModel)]="editor[1]"> การแก้ไข
            </mat-checkbox>
          </section>
        </div>
        <mat-progress-bar *ngIf="loading[2]" mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
  </div>

  <!-- เบิกเกี๊ยว -->
  <div class="row">
    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">รายการขอเกี๊ยว {{chooseyear}} โควตา {{farmercode}}</h3>
        <div class="card-tools">
          <button class="btn btn-success btn-sm" *ngIf="oneaskmoney.length>0" (click)="ExportExcel();">
            <i class="far fa-file-excel"></i></button>
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
        <mat-progress-bar mode="indeterminate" *ngIf="loading[0]"></mat-progress-bar>
      </div>
      <div class="card-body table-responsive p-2" style="max-height: 500px">
        <table class="table table-sm table-head-fixed table-bordered" #table>
          <thead>
            <tr style="text-align:center">
              <th><i class="far fa-clock" style="color: blue;"></i></th>
              <th>#</th>
              <th>เลขที่คำขอ</th>
              <th>หมายเลขแปลง</th>
              <th>วันที่</th>
              <th>โซน</th>
              <th> ชื่อ-นามสกุล </th>
              <th> เรื่องที่ขอ </th>
              <th> จำนวนเงิน </th>
              <th> ที่อนุมัติ </th>
              <th> สถานะ </th>
              <th *ngIf="editor[1]"> แก้ไข </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of oneaskmoney| filter:txtSearch ; let i = index;" style="text-align:center">
              <td>
                <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#Timeline"
                  (click)="Timeline([item])"> <i class="fas fa-clock"></i>
                </button>
              </td>
              <td>{{i+1}}</td>
              <td>{{item.docid}}</td>
              <td [ngStyle]="{ 'background-color': getColor(item.intlandno) }">{{item.intlandno}}</td>
              <td>{{THtoLocalstring(item.datepost)}}</td>
              <td>{{item.SUPZONE}}</td>
              <td>{{item.fmname}}</td>
              <td style="text-align:left">{{item.type_money_sub|json}}-{{item.comment1}}</td>
              <td style="text-align:right">{{item.money_amt|number}}</td>
              <td style="text-align:right">{{item.credit_approved|number}}</td>
              <td>{{item.docdesc}}</td>
              <td *ngIf="editor[1]">
                <button type="button" class="btn btn-sm btn-warning" (click)="check_edit(1);Edit_money(item)">
                  <i class="fas fa-edit"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <td></td>
            <td [colSpan]="2" class="text-left text-bold">รวม
              <span class="badge bg-success"> {{oneaskmoney.length}}</span>รายการ
            </td>
          </tfoot>
        </table>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
  <!-- เบิกเกี๊ยว -->

  <!-- เบิกปัจจัย -->
  <div class="row">
    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">รายการขอเบิกปัจจัยการผลิต {{chooseyear}} โควตา {{farmercode}} </h3>
        <div class="card-tools">
          <button class="btn btn-success btn-sm" *ngIf="onefactor.length>0" (click)="ExportExcel2();">
            <i class="far fa-file-excel"></i> </button>
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
        <mat-progress-bar mode="indeterminate" *ngIf="loading[1]"></mat-progress-bar>
      </div>
      <div class="card-body table-responsive p-2" style="max-height: 500px">
        <table class="table table-sm table-head-fixed table-bordered" #table2>
          <thead>
            <tr style="text-align:center">
              <th>#</th>
              <th>เลขที่คำขอ</th>
              <th>หมายเลขแปลง</th>
              <th>วันที่</th>
              <th>โซน</th>
              <th>สต็อค</th>
              <th>รายการ 1</th>
              <th>จำนวน</th>
              <th>รายการ 2</th>
              <th>จำนวน</th>
              <th>รายการ 3</th>
              <th>จำนวน</th>
              <th>รายการ 4</th>
              <th>จำนวน</th>
              <th>รายการ 5</th>
              <th>จำนวน</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of onefactor| filter:txtSearch ; let i = index;" style="text-align:center">
              <td>{{i+1}}</td>
              <td>{{item.docid}}</td>
              <td [ngStyle]="{ 'background-color': getColor(item.intlandno) }">{{item.intlandno}}</td>
              <td>{{THtoLocalstring(item.datepost)}}</td>
              <td>{{item.supzone}}</td>
              <td>{{item.Stockname}}</td>
              <td>{{item.desc1}}</td>
              <td>{{item.amt1.toLocaleString('ar-TH')}}</td>
              <td>{{item.desc2}}</td>
              <td>{{item.amt2.toLocaleString('ar-TH')}}</td>
              <td>{{item.desc3}}</td>
              <td>{{item.amt3.toLocaleString('ar-TH')}}</td>
              <td>{{item.desc4}}</td>
              <td>{{item.amt4.toLocaleString('ar-TH')}}</td>
              <td>{{item.desc5}}</td>
              <td>{{item.amt5.toLocaleString('ar-TH')}}</td>
            </tr>
          </tbody>
          <tfoot>
            <td [colSpan]="2" class="text-left text-bold">รวม
              <span class="badge bg-success"> {{onefactor.length}}</span> รายการ
            </td>
          </tfoot>
        </table>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</div>
<!-- content -->

<!-- Modal Timeline -->
<div class="modal fade" id="Timeline" tabindex="-1" role="dialog" aria-labelledby="TimelineLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngFor="let item of datainmodal">
      <div class="modal-header">
        <h5 class="modal-title" id="TimelineLabel">Timeline เลขที่คำขอ : {{item.docid}} </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="timeline">
          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-blue"><i class="fas fa-clock"></i> {{THtoLocalstring(item.datepost)}}</span>
          </div>
          <!-- /.timeline-label -->
          <!-- timeline item -->
          <div>
            <i class="fas fa-envelope bg-blue"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-blue">ผู้จัดการโซน - [{{item.sup_U}}]</h3>
              <div class="timeline-body">
                {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
              </div>

            </div>
          </div>
          <!-- END timeline item -->

          <div class="time-label">
            <span class="bg-yellow"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment3date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-comments bg-yellow"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-yellow">พนักงานสินเชื่อ - [{{item.fn_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment3}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- Start timeline item -->
          <div class="time-label">
            <span class="bg-green"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment4date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-user bg-green"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header no-border bg-green">หัวหน้าสินเชื่อ - [{{item.head_U}}]</h3>
              <div class="timeline-body">
                |{{item.comment4}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- Start timeline item -->
          <div class="time-label">
            <span class="bg-info"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment5date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-user bg-info"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header no-border bg-info">ผู้ช่วย ผจก.สินเชื่อ - [{{item.adj_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment5}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-purple"><i class="fas fa-clock"></i> {{THtoLocalstring(item.dateapprove)}}</span>
          </div>
          <!-- /.timeline-label -->
          <div>
            <i class="fas fa-tasks bg-purple"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-purple">ผจก.สินเชื่อ - [{{item.approve_U}}]</h3>
              <div class="timeline-body">
                | <div *ngIf="item.doc_status =='D'">ไม่อนุมัติ </div> {{item.comment6}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal Timeline -->

<!-- Modal -->
<div class="modal fade" id="edit_m" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" *ngIf="listqueue.length>0">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">รายการที่เลือกไว้ เลขที่คำขอ {{main_data.docid}} -
          {{main_data.fmname}}
          <span class="badge text-bg-secondary">{{main_data.credit_approved|number}}</span> บาท
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive p-2" style="height: 250px">
          <table class="table table-sm table-head-fixed table-bordered">
            <thead class="headText">
              <tr style="text-align:center">
                <th>หมายเลขแปลง</th>
                <th>วันที่</th>
                <th>โซน</th>
                <th>เรื่องที่ขอ</th>
                <th>เงินที่อนุมัติ</th>
                <th>สถานะ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listqueue ; let i = index" style="text-align:center">
                <td [ngStyle]="{'background-color': getColor(item.intlandno)}">{{item.intlandno}}</td>
                <td>{{THtoLocalstring(item.datepost)}}</td>
                <td>{{item.SUPZONE}}</td>
                <td style="text-align:left">{{item.type_money_sub|json}}-{{item.comment1}}</td>
                <td style="text-align:right">
                  <input type="number" [(ngModel)]="item.credit_approved"
                    style="text-align:right;background-color: bisque;" min="1"
                    [max]="i === 0 ? item.default_approved : item.credit_max" [disabled]="i === 0"
                    (change)="validateCreditApproved(i)" />
                </td>
                <td>{{item.docdesc}}</td>
                <td>
                  <button class="btn btn-outline-danger btn-sm" (click)="snaponedata(0,item);"
                    [disabled]="main_data.itid.trim() == item.itid.trim()">
                    <i class="fas fa-eye-slash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive p-2" style="height: 400px">
          <table class="table table-sm table-head-fixed table-bordered">
            <thead class="headText">
              <tr class="headText text-primary" style="text-align:center">
                <th>#</th>
                <th>เลขแปลง</th>
                <th>โซน</th>
                <th>ประเภท</th>
                <th>กรรมสิทธิ์</th>
                <th>พื้นที่</th>
                <th>ปลูกเสร็จ</th>
                <th>ค่าเช่าคงเหลือ</th>
                <th>ระยะสั้นคงเหลือ</th>
                <th>เลือก</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item2 of data_lands; let i = index;" style="text-align:center"
                [ngClass]="{'table-primary':sel_landno.itid == item2.itid}">
                <td>{{ i+1 }}</td>
                <td>{{ item2.intlandno }}</td>
                <td>{{ item2.supzone }}</td>
                <td>{{ item2.CaneTypeName }}</td>
                <td>
                  <b *ngIf="item2.Plottype == '1'">ตนเอง</b>
                  <b *ngIf="item2.Plottype == '2'">เช่า</b>
                </td>
                <td style="text-align:right">
                  {{ item2.landvalue | number:'1.2-2' }}
                </td>
                <td>{{ item2.PlantDate | adtob}}</td>
                <td style="text-align:right">{{ item2.balance_rent |number }}
                </td>
                <td style="text-align:right">{{ item2.balance_limit | number }}
                </td>
                <td>
                  <button class="btn btn-outline-success btn-sm" (click)="snaponedata(1,item2);"
                    [disabled]="main_data.intlandno.trim() == item2.intlandno.trim()">
                    <i class="fa fa-arrow-circle-up"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">บันทึกคำขอ</button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>